<template>
  <div>
    <BaseButtonSwitch
      :model-value="isVattable"
      :options="vattableOptions"
      class="mb-2 max-w-48"
      @update:model-value="handleVattableSwitch"
    />

    <template v-if="isVattable">
      <div class="flex space-x-2">
        <template v-for="rate in defaultRates" :key="rate">
          <button
            type="button"
            :class="[
              inputValue === rate
                ? 'bg-primary text-primary-fg'
                : '',
              'w-16 rounded-md border border-background-fg/6 px-3 py-2 font-semibold',
            ]"
            @click="setVatRate(rate)"
          >
            {{ rate }}%
          </button>
        </template>
        <div class="relative">
          <input
            type="number"
            :name="name"
            :class="[
              'block size-full rounded-md border border-background-fg/6 bg-background-fg/5 pr-9 text-center text-sm font-semibold',
              'focus:border-primary focus:outline-none focus:ring-primary',
            ]"
            inputmode="decimal"
            :value="inputValue"
            :aria-invalid="!!errorMessage"
            enterKeyHint="done"
            @input="handleVatTextInput"
            @blur="handleBlur"
            @keydown.backspace="handleBackspace"
            @keydown.enter="handleEnter"
          />
          <div
            class="absolute inset-y-0 right-0 flex w-9 items-center justify-center py-2"
          >
            <span class="text-sm font-semibold">%</span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="errorMessage">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"
const props = defineProps<{
  name: string
  label: string
}>()

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
} = useField<number | null>(toRef(props, "name"))

const { isUKmerchant } = useTenant()

const isVattable = computed(
  () =>
    inputValue.value !== null &&
    inputValue.value !== undefined
)

const setVatRate = (value: number | null) => {
  handleChange(value)
}

const defaultRates = computed(() =>
  isUKmerchant.value ? [0, 5, 20] : [0, 13.5, 23]
)

const vattableOptions = [
  {
    value: true,
    label: "VAT",
  },
  {
    value: false,
    label: "No VAT",
  },
]

const handleVattableSwitch = (value: boolean) => {
  if (value) {
    handleChange(0)
  } else {
    handleChange(null)
  }
}

const handleVatTextInput = (event: Event) => {
  const value = (event?.target as HTMLInputElement)
    ?.valueAsNumber
  if (!value) {
    handleChange(0)
    return
  }

  handleChange(value)
}

const handleBackspace = (event: KeyboardEvent) => {
  if (inputValue.value === 0) {
    event.preventDefault()
  }
}

const handleEnter = (event: Event) =>
  (event?.target as HTMLInputElement)?.blur()
</script>
